export const BANNER_CONSTANTS = {
    PlanExpiryText : "Subscription expired on ",
    STORAGE_BANNER : {
        "bannerTxt":"Storage almost full! Free up some space to keep adding files to JioAICloud.",
        "bannerBtn":"Manage",
        "redirectUrl":"userprofile",
        "showCloseButton":true,
        "bannerType":"storageFullOldBanner",
        "showBanner":true,
        "percentageUsed":"",
        "bannerClassName": "banner-theme-red",
        "bannerIconType": "NeueCloud-error"
    },
    PLAN_EXPIRY : {
        "bannerTxt":"",
        "bannerBtn":"Renew",
        "redirectUrl":"buystorage",
        "showCloseButton":true,
        "bannerType":"paidPlanExpiry",
        "showBanner":true,
        "bannerClassName": "banner-theme-red",
        "bannerIconType": "NeueCloud-error"
    },
    FREE_USER_QUOTA_EIGHTY_PERCENT_FULL : {
        "bannerTxt":"Storage is almost full (",
        "bannerBtn":"Manage",
        "redirectUrl":"userprofile",
        "showCloseButton":true,
        "bannerType":"freeUserAlmostFull",
        "showBanner":true,
        "bannerClassName": "banner-theme-orange",
        "bannerIconType": "NeueCloud-error"
    },
    FREE_USER_QUOTA_FULL : {
        "bannerTxt":"Storage is full. You won't be able to upload any new files.",
        "bannerBtn":"Manage",
        "redirectUrl":"userprofile",
        "showCloseButton":false,
        "bannerType":"freeUserFull",
        "showBanner":true,
        "bannerClassName": "banner-theme-red",
        "bannerIconType": "NeueCloud-error"
    },
    PAID_USER_QUOTA_EIGHTY_PERCENT_FULL : {
        "bannerTxt":"Storage is almost full (",
        "bannerBtn":"Upgrade",
        "redirectUrl":"buystorage",
        "showCloseButton":true,
        "bannerType":"paidUserAlmostFull",
        "showBanner":true,
        "bannerClassName": "banner-theme-orange",
        "bannerIconType": "NeueCloud-error"
    },
    PAID_USER_QUOTA_FULL : {
        "bannerTxt":"Storage is full. You won't be able to upload any new files.",
        "bannerBtn":"Upgrade",
        "redirectUrl":"buystorage",
        "showCloseButton":false,
        "bannerType":"paidUserFull",
        "showBanner":true,
        "bannerClassName": "banner-theme-red",
        "bannerIconType": "NeueCloud-error"
    }
}